import { hasPermission, hasActiveFeatureGate } from '@sopranodesign/pulse-auth';

import { VoiceCallLink } from './Pages/index';

const routes = [
  {
    name: 'Voice Call',
    path: '/voice-call-link',
    component: VoiceCallLink,
    canAccess: [
      hasActiveFeatureGate('channel - voice call'),
      hasPermission('view voice call settings')
    ],
    actions: []
  }
];

export default routes;
